<template>
  <div class="sharing-links-wrapper">
    <h1 class="page-header text-center">sharing links</h1>
    <loading-icon v-if="isLoading"></loading-icon>
    <div v-else-if="errorMessage" class="error-message">{{errorMessage}}</div>
    <div v-else class="row">
      <div class="sharing-links large-6 columns small-centered">
        <div :class="['login_preload_upload']">
          <label class="attachment-label" for="login_preload_image" name="login_preload_image">
            login/join link preload image
          </label>
          <img :src="preload_src" class="preload-placeholder-image">
          <input
              accept="image/png,image/jpeg"
              class="hide"  
              id="login_preload_image"
              ref="attachmentUpload"
              type="file"
              @change="processUpload"
              name="login_preload_image" />
          <p><a href=javascript:void(0) v-if="!attachment_info" @click="uploadImage" class="upload-instructions">add image</a></p>
          <p><a href=javascript:void(0) v-if="attachment_info" @click="removeImage" class="upload-instructions">remove image</a></p>
          <small v-if="uploadErrorMessage" class='file-warning error-label form-message'>{{uploadErrorMessage}}</small>
        </div>
        <div v-if="segmentTags" class="location-selector">
          <label>select the location you want sharing links for:</label>
          <input-dropdown
              :currentSelection="selectedSegmentTag"
              :dropdownOptions="segmentTags"
              dropdownType="groups"
              :isLoading="segmentTagsLoading"
              isSingleSelection
              :pagination="pagination"
              showCheckboxes
              showPagination
              showSearch
              wrapperClasses="sharing-links-locations"
              @changePage="changePage"
              @clearSearch="getSegmentTags"
              @delaySearchGroup="searchSegmentTags"
              @updateSelection="setSelectedSegmentTag">
          </input-dropdown>
        </div>
        <callout-bubble calloutClasses="text-center" label="login/join link" :labelDetail="labelLocationName">
          <div slot="content"><a :href="loginLink" target='_blank'>{{loginLink}}</a></div>
        </callout-bubble>
        <callout-bubble label="simple login/join button" :labelDetail="labelLocationName">
          <div slot="content">{{joinButton}}</div>
        </callout-bubble>
        <callout-bubble label="modal login/join button" :labelDetail="labelLocationName">
          <div slot="content">{{joinModal}}</div>
        </callout-bubble>
        <callout-bubble 
            label="login/join qr code" 
            :labelDetail="labelLocationName"
            wrapperClasses="qr-code-wrapper">
          <q-r-code 
              slot="content" 
              :itemRendered="loginLink"
              itemName="login-link-qr-code.jpeg">
          </q-r-code>
        </callout-bubble>
      </div>
    </div>
  </div>
</template>

<script>
import AxiosMixin from '../../mixins/AxiosMixin'
import CalloutBubble from '../../components/shared/CalloutBubble'
import InputDropdown from '../../components/FormItems/InputDropdown'
import LoadingIcon from '../../components/shared/LoadingIcon'
import QRCode from '../../components/shared/QRCode'
import axiosConfig from '../../../packs/axios'
import defaultImage from 'enrollnow/enrollnow_link_image.png'
import { mapState } from 'vuex'


export default {
  name: 'SharingLinks',

  components: {
    CalloutBubble,
    InputDropdown,
    LoadingIcon,
    QRCode
  },

  mixins: [AxiosMixin],

  data() {
    return {
      defaultSegmentTag: { tag: 'none', name: 'no location' },
      delayedSearch: null,
      errorMessage: null,
      iframeSrc: null,
      isLoading: true,
      joinUrl: null,
      loginUrl: null,
      segmentTags: null,
      page: 1,
      currentMerchant: null,
      pagination: {},
      selectedSegmentTag: null,
      uploadErrorMessage: null,
      preload_src: defaultImage,
      attachment_info: null
    }
  },

  methods: {
    changePage(page) {
      this.page = page
      this.getSegmentTags()
    },

    getSegmentTags(searchText) {
      this.segmentTagsLoading = true
      let url = `/api/v3/groups/merchant_taggings?context[]=locations&context[]=custom_groups&page=${this.page}`
      if (searchText) { url = `${url}&search=${searchText}` }
      this.axiosMethod({
        url, 
        onSuccess: this.setSegmentTags, 
        onError: this.setErrors
      })
    },

    getSharingLinks() {
      this.isLoading = true
      const url = '/api/v3/current_merchant/sharing_links'
      this.axiosMethod({
        url, 
        onSuccess: this.setSharingLinks, 
        onError: this.setErrors
      })
    },

    getPreloadImages() {
      this.isLoading = true;
      const url = '/api/v3/current_merchant/attachments'
      this.axiosMethod({
        url, 
        onSuccess: this.setPreloadImage, 
        onError: this.setErrors
      })
    },

    getCurrentMerchant() {
      this.isLoading = true;
      const url = '/api/v3/current_merchant'
      this.axiosMethod({
        url, 
        onSuccess: this.setCurrentMerchant, 
        onError: this.setErrors
      })
    },

    searchSegmentTags(searchText) {
      this.page = 1
      this.getSegmentTags(searchText)
    },

    setErrors(error) {
      const errorMessage = error ? `error loading: ${error}` : "error loading, please refresh or contact support"
      this.errorMessage = errorMessage
      this.isLoading = false
    },

    setSharingLinks(data) {
      if (data) {
        this.joinUrl = data.join_url
        this.loginUrl = data.login_url
        this.iframeSrc = data.iframe_url
      } else {
        this.setErrors()
      }
      this.isLoading = false
    },

    setPreloadImage(data) {
      this.attachment_info = data?.merchant_join_preload_image;
      if (this.attachment_info) {
        this.preload_src = this.attachment_info.url
      }
    },
    setCurrentMerchant(data){
      this.currentMerchant = data
    },

    setSegmentTags(data) {
      if (data) {
        const hasTags = data.taggings_count && data.taggings_count.length > 0
        this.segmentTags = hasTags ? [this.defaultSegmentTag, ...data.taggings_count] : null
        this.pagination = data.pagination
      } else {
        this.setErrors()
      }
      this.segmentTagsLoading = false
    },

    setSelectedSegmentTag(segmentTag) {
      this.selectedSegmentTag = segmentTag
    },
    uploadImage(){
      this.$refs.attachmentUpload.click();
    },
    removeImage(){
      axiosConfig.delete(`/api/v3/attachments/${this.attachment_info.uuid}`, null, {'Content-Type': 'multipart/form-data'})
        .then(()=> {
          this.preload_src = defaultImage;
          this.attachment_info = null;
        })
    },
    processUpload() {
      const uploadedFiles = this.$refs.attachmentUpload.files;
      const preview = this.preload_src
      const reader = new FileReader();

      if (this.validateUpdate(uploadedFiles)) {
        reader.readAsDataURL(uploadedFiles[0]);
        this.uploadAttachment(uploadedFiles[0]);
      }
    },
    uploadAttachment(file) {
      this.isLoading = true;
      let formData = new FormData()
      formData.append('file', file)
      formData.append('label', "merchant_join_preload_image")
      formData.append('owner_type', "Merchant")
      formData.append('owner_id', this.currentMerchant.id)
      axiosConfig.post('/api/v3/attachments', formData, {'Content-Type': 'multipart/form-data'})
      .then((response) => {
        this.attachment_info = response.data;
        this.preload_src = this.attachment_info.url
      })
      .finally(() => {
        this.isLoading = false;
      })
    },
    validateUpdate(files) {
      if (SpringBig.FormValidations.over_max_file_size(files)) {
        this.uploadErrorMessage = 'File is too large, select a file under 10MB';
        return false
      } else if (SpringBig.FormValidations.not_logo_filetype(files)){
        this.uploadErrorMessage = 'Only jpeg, jpg, and png formats are acceptable for preload icons'
        return false
      } else {
        this.uploadErrorMessage = null;
        return true
      }
    },
  },

  created() {
    this.getSharingLinks()
    this.getSegmentTags()
    this.getPreloadImages()
    this.getCurrentMerchant();
    this.selectedSegmentTag = this.defaultSegmentTag
  },

  computed: {
    isDefaultSegmentTag: function() {
      return this.selectedSegmentTag && this.selectedSegmentTag.tag === 'none'
    },

    joinButton: function() {
      const button = `<a href="${this.loginLink}" target='_blank'>
                        <button style='background-color: white; border: 1px solid #128ff9; border-radius: 5px; padding: 10px; color: #128ff9;'>
                          VIP Program Login/Join
                        </button>
                      </a>`
      return button
    },

    joinModal: function() {
      const script = `<script id="join-script" name="${this.loginLink}" src="${this.iframeSrc}"><\/script>
                            <a class="btn" href="#sbjoinbutton" rel="modal:open">VIP Program Login/Join</a>`
      return script
    },

    labelLocationName: function() {
      return this.isDefaultSegmentTag ? null : this.selectedSegmentTag.name
    },

    loginLink: function() {
      return this.isDefaultSegmentTag ? this.loginUrl : `${this.loginUrl}?location=${this.selectedSegmentTag.tag}`
    }
  },
}
</script>